import {
  Directive,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Optional,
  Output,
  PLATFORM_ID,
} from '@angular/core';
import { B2bScrollEndRootDirective } from '@app/b2b-scroll-lib/directives/b2b-scroll-end-root.directive';
/*import { LoggerService } from '@app/services/util-services/logger.service';*/
import { isPlatformBrowser } from '@angular/common';

export enum SCROLLEND_DIRECTION {
  DOWN = 'down',
  UP = 'UP',
}

@Directive({
  selector: '[scrollEnd]',
  standalone: true,
})
export class B2bScrollEndDirective implements OnInit, OnDestroy {
  @Output() scrolled: EventEmitter<any> = new EventEmitter();

  @Input() disabled: boolean = Boolean(false);
  @Input() rootMargin: string = String('0px 0px 0px 0px');
  @Input() threshold: number | number[] = Number(0.9);
  @Input('direction') desiredDirection: SCROLLEND_DIRECTION[] = [
    SCROLLEND_DIRECTION.DOWN,
    SCROLLEND_DIRECTION.UP,
  ];

  observer: IntersectionObserver;
  previousEntry: IntersectionObserverEntry;
  scrollDirection: SCROLLEND_DIRECTION;

  constructor(
    private el: ElementRef,
    @Optional() private scrollEndRoot: B2bScrollEndRootDirective,
    @Inject(PLATFORM_ID) private platformId: string,
  ) {}

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.configureIntersectionObserver();
    }
  }

  configureIntersectionObserver() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.scrollDirection =
            this.previousEntry?.boundingClientRect.bottom >
            entry.boundingClientRect.bottom
              ? SCROLLEND_DIRECTION.DOWN
              : SCROLLEND_DIRECTION.UP;

          this.scrolled.emit();

          /*if (
            !this.previousEntry?.isIntersecting &&
            entry.isIntersecting &&
            this.desiredDirection?.includes(this.scrollDirection)
          ) {
            /!*LoggerService.warn('Fire event from infinite scroller');*!/
            if (!this.disabled) {
              this.scrolled.emit();
            }
          }*/

          this.previousEntry = entry;
        });
      },
      {
        root: this.scrollEndRoot?.el.nativeElement,
        rootMargin: this.rootMargin,
        threshold: this.threshold,
      },
    );
    this.observer.observe(this.el.nativeElement);
  }

  complete() {
    this.observer?.disconnect();
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }
}
